<template>
  <div>
   <CRow>
      <CCol>
        <CCard>
          <CCardHeader>
             <strong> Artikel Erfassen </strong>
          </CCardHeader>
          <CCardBody>
            <form 
              @submit="checkForm"
              novalidate="true"
            >
              
              <div v-bind:class="{'d-none':this.profile.isRASPI || !this.profile.USER_ORDER_ON_BEHALF_RIGHT }">
                <div class="form-group">
                  <label for="formGroupCustomerNo">Kundennummer / Kunde</label>
                  <v-select v-model="selected" id="formGroupCustomerNo" label="displayname" :filterable="false" :options="userlist" @search="onCustomerSearch">
                    <template slot="no-options">
                      Suchbegriff oder Kundennummer eingeben um zu suchen
                    </template>
                    <template slot="option" slot-scope="userlist">
                      <div class="">
                        {{ userlist.displayname }} ({{ userlist.customerno }} )
                      </div>
                    </template>
                  </v-select>
                  </div>
                  <div class="form-group">
                    <label for="formGroupAmount">Menge</label>
                    <input v-model="amount" type="text" class="form-control" id="formGroupAmount" placeholder="1" />
                  </div>
              </div>
              <div class="form-group">
                <label for="formGroupArtNo">Artikelnummer</label>

                <v-select v-model="artno" id="formGroupArtNo" label="displayname" :taggable="true" :filterable="false" :options="artnoList" @input="onArtNoSelect" @search="onArtNoSearch">
                  <template slot="no-options">
                    Suchbegriff eingeben oder Barcode Scannen um zu suchen
                  </template>
                  <template slot="option" slot-scope="artnoList">
                    <div class="">
                      {{ artnoList.displayname }} 
                    </div>
                  </template>
                </v-select>

                <!--<input v-model="artno" type="text" class="form-control" id="formGroupArtNo" placeholder="" v-focus v-on:keypress="onKeyPress" v-on:keyup.enter="onBtnSubmit"/>-->
                
                <label for="formGroupArtMod">Modifizierer</label>


                <v-select v-model="artNoModSelected" id="formGroupArtNoMod" label="userarticlemodifier" :taggable="false" :filterable="false" :options="artNoMod" >
                  <template slot="no-options">
                    Noch keine Optionen geladen
                  </template>
                  <template slot="option" slot-scope="artNoMod">
                    <div class="">
                      {{ artNoMod.userarticlemodifier }}
                    </div>
                  </template>
                </v-select>


    

                
              </div>
              <button type="button" class="btn btn-success" @click="onBtnSubmit">Hinzufügen</button>
            </form>
            </CCardBody>
        </CCard>
        
        <CTableWrapper
          :items=orderList
          :fields=this.fields
          hover
          striped
          bordered
          small
          fixed
          sorter
          sorterValue = "{ column: 'id', asc: 'true' }"
          caption="Wunschliste"
          v-bind:highlightRow=this.highlightRow
        />

        <button :class="{'d-none' : !this.profile.USER_APPROVE_RIGHT }" type="button" class="btn btn-success" @click="onOrderCart" style="margin-left: 1em;">Warenkorb für diesen Kunden bestellen</button>
        <br/>
        <br/>
      </CCol>
    </CRow>
 
  </div>
  
</template>
<script>
  import CTableWrapper from './Table.vue'
  import { mapGetters, mapActions } from "vuex";

  export default {
    name: 'Order',
    components: { CTableWrapper },
    props: {
      value: String, // to support v-model
      foo: String, // to support :foo.sync
      multiple: false // to support multiple select
    },
    
    data() {
      return {
        selected: '',
        artno: '',
        artNoModSelected: '',
        amount: 1,

        artNoMod: [
          
        ],
        
        fields:  [
          {key:'id',label:'id',sorter:true},
          {key:'articleno',label:'Artikel',sorter:true},
          {key:'amount',label:'Menge',sorter:true},
          {key:'functions',label:'',sorter:false},
          {key:'status',label:'Status',sorter:true},
          {key:'order_time',label:'Bestelldatum',sorter:true}
           
        ],
        userlist:[],
        artnoList:[],
        highlightRow:[]
        

      };
    },
    computed : mapGetters(["orderList","profile","orderUserSelected"]),
    created() {

      if (this.selected.id > 0 ) {
    
      } else {
      
        this.selected = {id:this.profile.parent};
     
      }
      this.getOrderList({orderUserID:this.selected.id}); //user and searchtext
      
    },
    methods: {
      ...mapActions(['getOrderList','addOrder','orderCartByAgent','orderChangeAmount','setOrderUserSelected','setOrderListSearchtext']),

      onOrderCart: function() {
        let list = []; 
        this.orderList.map(function(value, key) {  list.push(value.id); });
        var ids = list.join(",");
        
        if (confirm('Möchten Sie wirklich den Warenkorb Bestellen?')) {
          this.orderCartByAgent(ids);
        } 

      },


      onArtNoSelect: function () {

          //loading(true);
          this.artNoModifierSearch(this.artno,this)



       
      },

      


      artNoModifierSearch(search,vm) {
        this.$axios
        .post('/',{event:'getartnomodifier', artno:this.artno, customerno:this.selected })
        .then(response => {vm.artNoMod = response.data.payload;} ) 
        .catch(error => console.log(error))
        //loading(false);
      },





      checkForm: function (e) {
        this.errors = [];
        e.preventDefault();
      },


      
      onBtnSubmit () {
        let formData = new FormData();

        formData.append('event', 'orderput');
        formData.append('userid', this.profile.id);

        if (this.profile.isRASPI === true) { //override if we use the RASBERRY
          
          formData.append('customerno', this.profile.parent)
          this.selected = {id:this.profile.parent};

        } else {

            if (this.selected.id > 0) {
              formData.append('customerno', this.selected.id);
            } else {
              alert("Bitte geben Sie eine Kundennummer ein!");
              return false;
            }

        }

        if (this.amount > 0) {
          formData.append('amount', this.amount);
        } else {
          alert("Bitte geben Sie eine Menge ein!");
          return false;
        }

        if (this.artno != '') {
          
          if ( this.artNoModSelected.product_ean != 'undefined'  ) {

            formData.append('artno', this.artNoModSelected.product_ean);

          } else {

            formData.append('artno', this.artno);

          }

          
        } else {
          alert("Bitte geben Sie eine Artikelnummer ein!");
          return false;
        }
        
        
        (async () => {
         const response = await this.addOrder(formData);
         this.clearRowBGColor();
         this.changeRowBGColor( parseInt(response) );
        })()
        
                
        this.artno = '';
        this.artNoModSelected = '';
        this.artNoMod = [];
        this.setFocus();
      },
      
      changeRowBGColor(rowId) {
        
        this.highlightRow.push(rowId);

      },
      
      clearRowBGColor() {
        this.highlightRow=[];
      },

      setFocus() {
        document.getElementById("formGroupArtNo").focus();
      },

      onCustomerSearch (search,loading) {
        loading(true);
        this.customerSearch(search,loading,this);
      },
      
      customerSearch(search,loading,vm) {
        this.$axios
        .post('/',{event:'userlist',search:search})
        .then(response => {vm.userlist = response.data.payload;} ) 
        .catch(error => console.log(error))
        loading(false);
      }
    },
    watch: {
      selected () {
        if ( this.selected !== null ) {
          this.setOrderUserSelected(this.selected);
          this.$emit('input', this.selected) // update v-model
          this.$emit('update:foo', this.selected) // update foo.sync
          
          this.getOrderList({orderUserID : this.selected.id});
        } else {
          // this.getOrderList({orderUserID:0});
        }
      },
      
      value () {
        this.selected = this.value // update from v-model
      },
      
      foo () {
        this.selected = this.foo // update from foo.sync
      }
    }
  }
</script>
